/* CustomFieldFormHeader.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ezzbk0g%7Bborder-block-end-color%3Avar(--ds-border-disabled%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12ornqa1%7Bborder-block-end-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18zr1ejb%7Bpadding-inline%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rjcpxbi%7Bpadding-block%3Avar(--ds-space-200%2C1pc)%7D");
import React from 'react';
import IconButton from '@atlaskit/button/icon/button';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import { FormattedMessage, useIntl } from 'react-intl';
type CustomFieldFormHeaderProps = {
  mode: 'create' | 'edit';
  onClose: () => void;
};
const styles = {
  header: "_1rjcpxbi _18zr1ejb _12ornqa1 _1ezzbk0g"
};
export const CustomFieldFormHeader = ({
  mode,
  onClose
}: CustomFieldFormHeaderProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  return <Inline spread="space-between" alignBlock="center" xcss={styles.header}>
			<Text weight="semibold" color="color.text.subtle" size="medium">
				{mode === 'create' ? <FormattedMessage id="townsquare.teams-settings.custom-field-form.create-title" defaultMessage="Create field" description="Title for create custom field form" /> : <FormattedMessage id="townsquare.teams-settings.custom-field-form.edit-title" defaultMessage="Edit field" description="Title for edit custom field form" />}
			</Text>
			<IconButton icon={CrossIcon} label={formatMessage({
      id: 'townsquare.teams-settings.custom-field-form.close-button',
      defaultMessage: 'Close',
      description: 'Close button label for custom field form'
    })} onClick={onClose} />
		</Inline>;
};